import { render, staticRenderFns } from "./DesignSystem.vue?vue&type=template&id=425fc77a&lang=pug&"
import script from "./DesignSystem.vue?vue&type=script&lang=js&"
export * from "./DesignSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports